import { render, staticRenderFns } from "./LandPage.vue?vue&type=template&id=1832acde&scoped=true"
import script from "./LandPage.vue?vue&type=script&lang=js"
export * from "./LandPage.vue?vue&type=script&lang=js"
import style0 from "./LandPage.vue?vue&type=style&index=0&id=1832acde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1832acde",
  null
  
)

export default component.exports